var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBulbIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3307 5.99935C13.3307 3.05402 10.9427 0.666016 7.9974 0.666016C5.05206 0.666016 2.66406 3.05402 2.66406 5.99935C2.66406 8.23735 4.0434 10.15 5.9974 10.9413V12.666H9.9974V10.9413C11.9514 10.15 13.3307 8.23735 13.3307 5.99935Z",
    stroke: "#680DDB",
    strokeWidth: 1.33333,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 15.332H10",
    stroke: "#680DDB",
    strokeWidth: 1.33333,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.32812 6L6.66146 7.33333L7.99479 6L9.32813 7.33333L10.6615 6",
    stroke: "#680DDB",
    strokeWidth: 1.33333,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulbIcon);
export default __webpack_public_path__ + "static/media/bulb_icon.4e6b0df3b30e32929e05b8dc29506122.svg";
export { ForwardRef as ReactComponent };